import { createContext, useContext } from "react";

type SetContainerHeight = React.Dispatch<React.SetStateAction<number | undefined>>;

const ReadMoreButtonHeightContext = createContext<SetContainerHeight | undefined>(undefined);

export const ReadMoreButtonHeightProvider = ReadMoreButtonHeightContext.Provider;

// ReadMoreButton 内に配置された子コンポーネントが、自身の高さを折りたたみ高さとして
// 報告するための hook。ReadMoreButton の外で使われた場合は undefined を返すため、
// 呼び出し側で存在チェックしてから利用すること。
export const useReadMoreButtonHeight = (): SetContainerHeight | undefined =>
  useContext(ReadMoreButtonHeightContext);
